import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DataService from '../../services/data.service';
import { toast } from 'react-toastify';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Load email if remembered
  useEffect(() => {
    const rememberedEmail = localStorage.getItem('rememberedEmail');
    if (rememberedEmail) {
      setFormData((prev) => ({ ...prev, email: rememberedEmail }));
      setRememberMe(true);
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.password) newErrors.password = 'Password is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    // Store or remove remembered email
    if (rememberMe) {
      localStorage.setItem('rememberedEmail', formData.email);
    } else {
      localStorage.removeItem('rememberedEmail');
    }

    DataService.loginUser(formData)
      .then((res) => {
        DataService.setAccessToken(res.data.token);
        DataService.setUserDetails(res.data.user);
        navigate('/dashboard');
      })
      .catch(() => toast.error('Invalid Username/Password'))
      .finally(() => setLoading(false));
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-form-section">
          <h3 className="text-center mb-4">Sign In</h3>

          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Username"
                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>

            <div className="form-group">
              <input
                type="password"
                name="password"
                placeholder="Password"
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                value={formData.password}
                onChange={handleChange}
              />
              {errors.password && <div className="invalid-feedback">{errors.password}</div>}
            </div>

            <button type="submit" className="login-btn">
              {loading ? 'Signing In...' : 'Sign In'}
            </button>

            <div className="form-options mt-3">
              <label className="remember-me">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                />{' '}
                Remember Me
              </label>
            </div>
          </form>
        </div>

        <div className="login-welcome-section">
          <div className="text-center mb-4">
            <img
              src="/images/Logo_salon.svg"
              alt="Divine Blush Beauty Logo"
              style={{ height: '80px', marginBottom: '10px', filter: 'brightness(0) invert(1)' }}
            />
            <h2 className="navbar-brand" style={{ color: 'white' }}>
              Divine Blush Beauty
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
